import { Application } from 'stimulus';
import LeadFormController from './controllers/lead_form_controller';

const startStimulus = () => {
  const application = Application.start();
  application.register('leadForm', LeadFormController);
};

export default startStimulus;
